const sanitizeDownloadFileName = (value, fallback) => {
  const normalized = String(value || "")
    .replace(/[\\/\0-\x1f\x7f]/g, "-")
    .trim();
  return normalized || fallback;
};

export const getDownloadFileName = (contentDisposition, fallback) => {
  const header = String(contentDisposition || "");
  const encodedMatch = header.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (encodedMatch?.[1]) {
    try {
      return sanitizeDownloadFileName(decodeURIComponent(encodedMatch[1].trim()), fallback);
    } catch (error) {
      // Fall through to the regular filename parameter.
    }
  }

  const filenameMatch = header.match(/filename\s*=\s*(?:"([^"]*)"|([^;\s]+))/i);
  return sanitizeDownloadFileName(filenameMatch?.[1] || filenameMatch?.[2], fallback);
};
